<script lang="ts">
	import type { DataType } from "#gen/common/v1/types_pb.js";
	import { inputComponentForDataType } from "#lib/components/flow/editor/data-types/dataTypes.js";
	import type { DataTypeInputProps, InputControl } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";

	interface Props extends Omit<DataTypeInputProps, "type" | "autocomplete" | "inputmode"> {
		dataType: DataType;
	}

	let { dataType, value = $bindable(), defaultValue, disabled, invalid, required, fullPath, oninput, onchange, onblur, oninvalid }: Props = $props();
	const InputComponent: InputControl = $derived(inputComponentForDataType(dataType));
</script>

<InputComponent.component bind:value {disabled} {invalid} {required} {defaultValue} {fullPath} type={InputComponent.attrs?.type} autocomplete={InputComponent.attrs?.autocomplete} inputmode={InputComponent.attrs?.inputmode} {oninput} {onchange} {onblur} {oninvalid} />
